(function () {
	function addParam(url, key, value) {
		if (!url || url.indexOf(key + '=') !== -1) {
			return url;
		}
		return url + (url.indexOf('?') === -1 ? '?' : '&') + key + '=' + value;
	}

	function removeParam(url, key) {
		if (!url) {
			return url;
		}
		return url.replace(new RegExp('([?&])' + key + '=[^&]*(&?)', 'g'), function (match, sep, trailing) {
			return trailing ? sep : '';
		}).replace(/[?&]$/, '');
	}

	function isNoAutoplay(root) {
		return !!(root && root.hasAttribute('data-video-no-autoplay'));
	}

	function embedHidden(node) {
		var embed = node && node.closest ? node.closest('.header-video__embed, .img_text-video__embed') : null;
		return !!(embed && window.getComputedStyle(embed).display === 'none');
	}

	function visibleNode(root, selector) {
		if (!root) {
			return null;
		}

		var nodes = root.querySelectorAll(selector);
		for (var i = 0; i < nodes.length; i++) {
			if (!embedHidden(nodes[i])) {
				return nodes[i];
			}
		}

		return null;
	}

	function pauseHiddenVideos(root) {
		if (!root) {
			return;
		}

		var videos = root.querySelectorAll('video');
		for (var i = 0; i < videos.length; i++) {
			if (embedHidden(videos[i]) && !videos[i].paused) {
				videos[i].pause();
			}
		}
	}

	function playVideoEl(video, withSound) {
		if (!video) {
			return;
		}

		video.playsInline = true;
		video.loop = true;
		video.muted = !withSound;

		var attempt = function () {
			var playPromise = video.play();
			if (playPromise && typeof playPromise.catch === 'function') {
				playPromise.catch(function () {
					if (withSound) {
						return;
					}
					video.muted = true;
					video.play().catch(function () {});
				});
			}
		};

		attempt();
		if (!withSound) {
			window.setTimeout(attempt, 250);
		}
	}

	function revealWhenPlaying(root, video) {
		if (!root) {
			return;
		}

		if (!video) {
			root.classList.add('is-playing');
			root.classList.remove('is-buffering');
			return;
		}

		if (!video.paused && video.readyState >= 3) {
			root.classList.add('is-playing');
			root.classList.remove('is-buffering');
			return;
		}

		root.classList.add('is-buffering');

		var settled = false;
		function finish() {
			if (settled) {
				return;
			}
			settled = true;
			video.removeEventListener('playing', finish);
			window.clearTimeout(timeout);
			root.classList.add('is-playing');
			root.classList.remove('is-buffering');
		}

		video.addEventListener('playing', finish);
		var timeout = window.setTimeout(finish, 8000);
	}

	function pauseRoot(root, fromUser) {
		if (!root) {
			return;
		}

		var videos = root.querySelectorAll('video');
		for (var i = 0; i < videos.length; i++) {
			if (!videos[i].paused) {
				videos[i].pause();
			}
		}

		if (fromUser) {
			root.setAttribute('data-video-paused', '1');
			root.classList.add('is-paused');
			root.classList.remove('is-playing');
		}
	}

	function playRoot(root, withSound) {
		if (!root) {
			return;
		}

		if (!withSound && root.getAttribute('data-video-paused') === '1') {
			return;
		}

		root.removeAttribute('data-video-paused');
		root.classList.remove('is-paused');

		pauseHiddenVideos(root);

		var iframe = visibleNode(root, 'iframe');
		var useSound = withSound && !root.classList.contains('is-muted');
		if (iframe) {
			var src = iframe.getAttribute('src') || '';
			if (src) {
				src = addParam(src, 'autoplay', '1');
				src = addParam(src, 'loop', '1');
				var yt = src.match(/youtube(?:-nocookie)?\.com\/embed\/([^?&/]+)/);
				if (yt && yt[1]) {
					src = addParam(src, 'playlist', yt[1]);
				}
				if (!useSound) {
					src = addParam(src, 'mute', '1');
					src = addParam(src, 'muted', '1');
				} else {
					src = removeParam(src, 'mute');
					src = removeParam(src, 'muted');
				}
				if (iframe.getAttribute('src') !== src) {
					iframe.setAttribute('src', src);
				}
			}
		}

		var video = visibleNode(root, 'video');
		revealWhenPlaying(root, video);
		playVideoEl(video, useSound);
	}

	function setMuted(root, muted) {
		if (!root) {
			return;
		}

		root.classList.toggle('is-muted', muted);

		var video = visibleNode(root, 'video');
		if (video) {
			video.muted = muted;
		}

		var iframe = visibleNode(root, 'iframe');
		if (iframe) {
			var src = iframe.getAttribute('src') || '';
			if (src) {
				if (muted) {
					src = addParam(src, 'mute', '1');
					src = addParam(src, 'muted', '1');
				} else {
					src = removeParam(src, 'mute');
					src = removeParam(src, 'muted');
				}
				if (iframe.getAttribute('src') !== src) {
					iframe.setAttribute('src', src);
				}
			}
		}

		var muteBtn = root.querySelector('[data-img-text-video-mute]');
		if (muteBtn) {
			muteBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
			muteBtn.setAttribute(
				'aria-label',
				muted ? 'Ton einschalten' : 'Ton aus'
			);
		}
	}

	document.addEventListener('click', function (event) {
		var mute = event.target.closest('[data-img-text-video-mute]');
		if (mute) {
			event.preventDefault();
			event.stopPropagation();
			var muteRoot = mute.closest('[data-img-text-video]');
			if (!muteRoot) {
				return;
			}
			setMuted(muteRoot, !muteRoot.classList.contains('is-muted'));
			return;
		}

		var poster = event.target.closest('[data-img-text-video-poster]');
		if (!poster) {
			return;
		}

		var root = poster.closest('[data-img-text-video]');
		if (!root) {
			return;
		}

		event.preventDefault();

		var playBtn = root.querySelector('.header-video__control--play') || poster;
		var video = visibleNode(root, 'video');
		if (video && !video.paused) {
			pauseRoot(root, true);
			playBtn.setAttribute('aria-label', 'Video abspielen');
			return;
		}

		playBtn.setAttribute('aria-label', 'Video anhalten');
		playRoot(root, true);
	});

	function observeVideos() {
		var roots = document.querySelectorAll('[data-img-text-video]');
		if (!roots.length) {
			return;
		}

		for (var i = 0; i < roots.length; i++) {
			if (!isNoAutoplay(roots[i])) {
				continue;
			}
			var idleVideos = roots[i].querySelectorAll('video');
			for (var v = 0; v < idleVideos.length; v++) {
				idleVideos[v].autoplay = false;
				idleVideos[v].pause();
			}
		}

		if (!('IntersectionObserver' in window)) {
			return;
		}

		var observed = [];
		for (var i = 0; i < roots.length; i++) {
			if (isNoAutoplay(roots[i])) {
				continue;
			}
			var section = roots[i].closest('.section') || roots[i];
			if (observed.indexOf(section) === -1) {
				observed.push(section);
			}
		}

		if (!observed.length) {
			return;
		}

		var io = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					var videos = entry.target.matches('[data-img-text-video]')
						? [entry.target]
						: entry.target.querySelectorAll('[data-img-text-video]');

					for (var j = 0; j < videos.length; j++) {
						if (isNoAutoplay(videos[j])) {
							continue;
						}
						if (entry.isIntersecting) {
							playRoot(videos[j], false);
						} else {
							pauseRoot(videos[j]);
						}
					}
				});
			},
			{
				threshold: 0,
				rootMargin: '0px 0px -20% 0px',
			}
		);

		observed.forEach(function (section) {
			io.observe(section);
		});
	}

	var mobileVideoQuery = window.matchMedia('(max-width: 575.98px)');

	function syncVideoBreakpoint() {
		var roots = document.querySelectorAll('[data-img-text-video]');
		for (var i = 0; i < roots.length; i++) {
			var root = roots[i];
			if (root.getAttribute('data-video-paused') === '1') {
				pauseRoot(root, true);
				continue;
			}

			var videos = root.querySelectorAll('video');
			var active = root.classList.contains('is-playing');
			for (var v = 0; v < videos.length; v++) {
				if (!videos[v].paused) {
					active = true;
				}
			}
			if (!active) {
				pauseHiddenVideos(root);
				continue;
			}

			playRoot(root, isNoAutoplay(root));
		}
	}

	if (mobileVideoQuery.addEventListener) {
		mobileVideoQuery.addEventListener('change', syncVideoBreakpoint);
	} else if (mobileVideoQuery.addListener) {
		mobileVideoQuery.addListener(syncVideoBreakpoint);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', observeVideos);
	} else {
		observeVideos();
	}
})();
